/**
 * @generated SignedSource<<89bfc8d0137870756097aa87eee55420>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchFilter = "ONLY_ACTIONS";
export type ProductExpireBatchFilterSortField = "CREATED_AT" | "EXPIRE_AT";
export type ProductDateTrackerListPaginationQuery$variables = {
  after?: string | null;
  filter?: ProductExpireBatchFilter | null;
  first?: number | null;
  id: string;
  order?: ProductExpireBatchFilterSortField | null;
};
export type ProductDateTrackerListPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductDateTrackerList_Store">;
  } | null;
};
export type ProductDateTrackerListPaginationQuery = {
  response: ProductDateTrackerListPaginationQuery$data;
  variables: ProductDateTrackerListPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "order"
  }
],
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timezone",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductDateTrackerListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductDateTrackerList_Store"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductDateTrackerListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "StoreProductExpireBatchConnection",
                "kind": "LinkedField",
                "name": "productExpireBatches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatchEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreProductExpireBatch",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreProductExpireBatchAction",
                            "kind": "LinkedField",
                            "name": "activeAction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoreZonedDate",
                                "kind": "LinkedField",
                                "name": "startAtDate",
                                "plural": false,
                                "selections": (v9/*: any*/),
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "expireAtDate",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreProduct",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "partNumber",
                                "storageKey": null
                              },
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isProductDetails"
                              }
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "filter",
                  "orderBy"
                ],
                "handle": "connection",
                "key": "ProductDateTracker__productExpireBatches",
                "kind": "LinkedHandle",
                "name": "productExpireBatches"
              }
            ],
            "type": "Store",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75df740698e335ce2aef4600f507c44b",
    "id": null,
    "metadata": {},
    "name": "ProductDateTrackerListPaginationQuery",
    "operationKind": "query",
    "text": "query ProductDateTrackerListPaginationQuery(\n  $after: String\n  $filter: ProductExpireBatchFilter\n  $first: Int\n  $order: ProductExpireBatchFilterSortField\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ProductDateTrackerList_Store\n    id\n  }\n}\n\nfragment ProductDateTrackerList_Store on Store {\n  productExpireBatches(after: $after, first: $first, filter: $filter, orderBy: $order) {\n    edges {\n      cursor\n      node {\n        id\n        activeAction {\n          startAtDate {\n            isoString\n            timezone\n          }\n          id\n        }\n        ...ProductExpireBatchListItem_StoreProductExpireBatch\n        expireAtDate {\n          isoString\n          timezone\n          ...StoreRelativeZonedDate_StoreZonedDate\n        }\n        status\n        product {\n          id\n          name\n          imageUrl\n          partNumber\n          ...ProductHeader_ProductDetails\n          ...ProductExpireBatchProductPreview_StoreProduct\n        }\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ProductExpireBatchListItemAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {\n  id\n  label\n  status\n  startAtDate {\n    isoString\n    timezone\n    ...StoreRelativeZonedDate_StoreZonedDate\n  }\n}\n\nfragment ProductExpireBatchListItemContent_StoreProductExpireBatch on StoreProductExpireBatch {\n  id\n  expireAtDate {\n    isoString\n  }\n  product {\n    id\n    name\n    imageUrl\n  }\n}\n\nfragment ProductExpireBatchListItem_StoreProductExpireBatch on StoreProductExpireBatch {\n  id\n  activeAction {\n    id\n    ...ProductExpireBatchListItemAction_StoreProductExpireBatchAction\n  }\n  ...ProductExpireBatchListItemContent_StoreProductExpireBatch\n}\n\nfragment ProductExpireBatchProductPreview_StoreProduct on StoreProduct {\n  id\n  name\n  partNumber\n  imageUrl\n}\n\nfragment ProductHeader_ProductDetails on ProductDetails {\n  __isProductDetails: __typename\n  imageUrl\n  partNumber\n  name\n}\n\nfragment StoreRelativeZonedDate_StoreZonedDate on StoreZonedDate {\n  isoString\n  timezone\n}\n"
  }
};
})();

(node as any).hash = "bfc95da6f14be5d0275f906c2e2eae50";

export default node;
